import { useEffect, useState } from "react";
import { api, GENRES, ROLES } from "@/lib/api";
import { ArtistCard } from "@/components/fo/ArtistCard";
import { SectionHead } from "@/components/fo/Bits";

const Chip = ({ on, onClick, children, testid }) => (
  <button data-testid={testid} onClick={onClick}
    className={`rounded-full border px-4 py-1.5 font-mono text-[11px] uppercase tracking-widest transition-colors ${on ? "border-[#FF2E63] bg-[#FF2E63] text-white" : "border-white/15 text-slate-400 hover:border-white/40 hover:text-white"}`}>
    {children}
  </button>
);

export default function Artists() {
  const [genre, setGenre] = useState("");
  const [role, setRole] = useState("");
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/artists", { params: { genre, role } }).then((r) => setList(r.data)); }, [genre, role]);
  return (
    <div className="mx-auto max-w-7xl px-4 pb-24 pt-28 md:px-8" data-testid="artists-page">
      <SectionHead label="Showcase" title="The artists">Every artist here was selected by our team. Tap a card for their link-in-bio page, tracks and live chart position.</SectionHead>
      <div className="mb-4 flex flex-wrap gap-2">
        <Chip on={!role} onClick={() => setRole("")} testid="filter-role-all">All roles</Chip>
        {ROLES.map(([v, l]) => <Chip key={v} on={role === v} onClick={() => setRole(v)} testid={`filter-role-${v}`}>{l}</Chip>)}
      </div>
      <div className="no-scrollbar mb-10 flex gap-2 overflow-x-auto">
        <Chip on={!genre} onClick={() => setGenre("")} testid="filter-genre-all">All genres</Chip>
        {GENRES.map((g) => <Chip key={g} on={genre === g} onClick={() => setGenre(g)} testid={`filter-genre-${g}`}>{g}</Chip>)}
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4" data-testid="artists-grid">
        {list?.map((a, i) => <ArtistCard key={a.id} a={a} i={i} />)}
      </div>
      {list && !list.length && <p className="py-20 text-center text-slate-500" data-testid="artists-empty">No artists match these filters yet.</p>}
    </div>
  );
}
